import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import PreviewCard from '../../PreviewCard';

const ListaEnProgreso = ({ concursos, title }) => {
  const [sortedConcursos, setSortedConcursos] = useState([]);

  useEffect(() => {
    setSortedConcursos([...concursos].sort((a, b) => (a.fmodificacion > b.fmodificacion ? -1 : 1)));
  }, [concursos]);
  const classes = createUseStyles({
    container: {
      marginTop: 10,
    },
  })();
  if (concursos.length > 0) {
    return (
      <Container fluid className={classes.container}>
        <Row>
          <Col>
            <h4 className="text-info text-center">
              <span>{title}</span>
            </h4>
          </Col>
        </Row>
        <Row sm={1} lg={4}>
          {sortedConcursos.map((con, idx) => (
            <Col key={idx} className="d-flex justify-content-center">
              <PreviewCard con={con} />
            </Col>
          ))}
        </Row>
      </Container>
    );
  } else {
    return <></>;
  }
};

export default ListaEnProgreso;
